type Block =
  | 'selection_block_list'
  | 'selection_block_pop_in_list'
  | 'selection_text_list';

export const GTM_SWITCH_MODEL = (blockClicked: Block, productName = '') => ({
  event: 'interaction_switch model',
  e_category: 'Navigation',
  e_action: 'switch model',
  e_label: blockClicked,
  event_trigger: productName,
  amp_event_name: 'Switch model',
  block_clicked: blockClicked,
});
export const GTM_CLICK_ON_MODELS_SELECTION = (blockClicked: Block) => ({
  event: 'interaction_click on models selection',
  e_category: 'ecommerce',
  e_action: 'Click on models selection',
  e_label: blockClicked,
  event_trigger: 'product_page',
  amp_event_name: 'Click on models selection',
  block_clicked: blockClicked,
});
